import { useState } from 'react';
import {
  defaultClearEmailBody,
  defaultClearEmailSubject,
  defaultClearTextMessage,
  defaultTriggerEmailBody,
  defaultTriggerEmailSubject,
  defaultTriggerTextMessage,
  EMAIL_TEMPLATE_TYPE,
  SMS_TEMPLATE_TYPE,
} from '../../../utility/AlertNotificationTemplateUtils';

export const defaultTemplate = {
  name: 'New Template',
  useDefaultEmailTemplate: true,
  useDefaultSmsTemplate: true,
  triggeredEmailSubject: defaultTriggerEmailSubject,
  triggeredEmailBody: defaultTriggerEmailBody,
  triggeredSmsBody: defaultTriggerTextMessage,
  clearedEmailSubject: defaultClearEmailSubject,
  clearedEmailBody: defaultClearEmailBody,
  clearedSmsBody: defaultClearTextMessage,
};

const useNotificationTemplate = ({
  initialTemplate = defaultTemplate,
  clone = false,
}) => {
  const startingTemplate = { ...initialTemplate };
  if (clone) {
    startingTemplate.id = undefined;
    startingTemplate.name = `${initialTemplate.name} (Clone)`;
  }
  const [template, setTemplate] = useState(startingTemplate);

  const updateTemplate = (name, value) => {
    setTemplate({
      ...template,
      [name]: value,
    });
  };

  const resetTemplateByType = (type) => {
    if (type === EMAIL_TEMPLATE_TYPE) {
      setTemplate({
        ...template,
        useDefaultEmailTemplate: true,
        triggeredEmailSubject: defaultTemplate.triggeredEmailSubject,
        triggeredEmailBody: defaultTemplate.triggeredEmailBody,
        clearedEmailSubject: defaultTemplate.clearedEmailSubject,
        clearedEmailBody: defaultTemplate.clearedEmailBody,
      });
    } else if (type === SMS_TEMPLATE_TYPE) {
      setTemplate({
        ...template,
        useDefaultSmsTemplate: true,
        triggeredSmsBody: defaultTemplate.triggeredSmsBody,
        clearedSmsBody: defaultTemplate.clearedSmsBody,
      });
    }
  };

  // const resetAllTemplateTypes = () => setTemplate(defaultTemplate);

  return {
    template,
    setTemplate,
    updateTemplate,
    resetTemplateByType,
    // resetAllTemplateTypes,
  };
};

export default useNotificationTemplate;
